import image from '../../../assets/images/header2.png';

const Header = () => {
    return (
        <div style={{ position: 'relative', width: '100vw', height: '120vh' }}>
            <div className="header-image">
                <img src={image} alt='header-image' />
                {/* <div className="image-overlay" /> */}
            </div>
            <h1 className="header-text" >Andrea & David</h1>
        </div>
    );
};

export default Header;